import { format, parseISO } from 'date-fns';

export default function FormatDate({ date, format: dateFormat = 'd MMM yyyy' }) {
  // Try to parse the date
  try {
    const parsedDate = typeof date === 'string' ? parseISO(date) : new Date(date);

    // Check if the date is valid
    if (isNaN(parsedDate.valueOf())) {
      return null;
    }

    const formattedDate = format(parsedDate, dateFormat);

    return <time suppressHydrationWarning dateTime={date} className={`italic`}>{formattedDate}</time>;
  } catch (error) {
    console.error('Error formatting date:', error);
    return null;
  }
}
